<form
  class="resources-search-form"
  ngNoForm
  [action]="formAction"
  method="GET"
  (submit)="submitSearch()"
  [attr.target]="!resourcesPage ? 'resourcesWindow' : '_self'"
>
  <label for="query" class="cdk-visually-hidden">Search Resources</label>
  <input
    #searchInput
    class="resources-search-form__input"
    id="query"
    name="query"
    cignaInput
    type="text"
    placeholder="Search Resources"
  />
  <button
    class="resources-search-form__button"
    type="submit"
    aria-label="Search"
  >
    <cigna-icon type="search"></cigna-icon>
  </button>
</form>
